import ClassroomParamsItem from "./ClassroomParamsItem";
export default ClassroomParamsItem;
